import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { OtpFormControlComponent } from '../../../components/form/strong-customer-authentication/otp/otp-form-control.component';
import { AuthenticatedSCAOptionsComponent } from '../../../components/form/strong-customer-authentication/authenticated-sca-options/authenticated-sca-options.component';
import { PasscodeModule } from '../passcode/passcode.module';
import { CommonComponentsModule } from '../common/common.module';
import { LoadingModule } from '../loading/loading.module';
import { TextMaskModule } from 'angular2-text-mask';
import { ExpanderModule } from '../expander/expander.module';
import { OtpInputComponent } from '../../../components/form/strong-customer-authentication/otp-input/otp-input.component';
import { MoveFocusOnNumberInputDirective } from '../../../components/form/strong-customer-authentication/directives/moveFocusOnNumberInput.directive';
import { InvalidInputFocusDirectiveModule } from '../../directives/invalidInputFocusDirective/invalidInputFocusDirective.module';
import { ShowSecretToggleModule } from '../show-secret-toggle/show-secret-toggle.module';
import { CommonLoggedOutComponentsModule } from '../common-logged-out/common-logged-out.module';
import { ValidationMessagesModule } from '../validation-messages/validation-messages.module';
import { SelectOtpChannelFormComponent } from '../../../components/form/strong-customer-authentication/select-otp-channel-form/select-otp-channel-form.component';
import { DynamicAccountQuestionFormComponent } from '../../../components/form/strong-customer-authentication/dynamic-account-question-form/dynamic-account-question-form.component';
import { InputCodeFormComponent } from '../../../components/form/strong-customer-authentication/input-code-form/input-code-form.component';
import { ErrorSectionComponent } from '../../../components/form/strong-customer-authentication/error-section/error-section.component';
import { AuthenticatedScaOptionsService } from '../../../components/form/strong-customer-authentication/authenticated-sca-options/authenticated-sca-options.service';
import { ResendCountdownComponent } from '../../../components/form/strong-customer-authentication/resend-countdown/resend-countdown.component';

@NgModule({
  declarations: [
    OtpFormControlComponent,
    AuthenticatedSCAOptionsComponent,
    OtpInputComponent,
    MoveFocusOnNumberInputDirective,
    SelectOtpChannelFormComponent,
    DynamicAccountQuestionFormComponent,
    InputCodeFormComponent,
    ErrorSectionComponent,
    ResendCountdownComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    CommonComponentsModule,
    PasscodeModule,
    LoadingModule,
    TextMaskModule,
    ExpanderModule,
    InvalidInputFocusDirectiveModule,
    ShowSecretToggleModule,
    CommonLoggedOutComponentsModule,
    ValidationMessagesModule,
  ],
  exports: [
    OtpFormControlComponent,
    AuthenticatedSCAOptionsComponent,
    OtpInputComponent,
    SelectOtpChannelFormComponent,
    DynamicAccountQuestionFormComponent,
    InputCodeFormComponent,
    ErrorSectionComponent,
    ResendCountdownComponent,
  ],
  providers: [AuthenticatedScaOptionsService],
})
export class StrongCustomerAuthenticationModule {}
